export { default } from './Body';
// @ts-ignore
export { default as BodyIcon } from './Icon.svg';